<template>
<div id="ManageServiceType">
   <ServiceType :AllowEdit="true"></ServiceType>
</div>
</template>
<script>
import ServiceType from '@/components/DPEBB/Administrator/ServiceType.vue';
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {

data: function () {
    return {
            AppServiceID :6,
        }
    },
 components: {
    ServiceType  : ServiceType

        },
   created: function() {
            this.$emit('update:layout', LayoutDefault);
    },
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetDPEBBServiceID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetDPEBBServiceID);
    },
}
</script>
